//User Types

export const USERLOGIN_REQUEST = 'USERLOGIN_REQUEST';
export const USERLOGIN_SUCCESS = 'USERLOGIN_SUCCESS';
export const USERLOGIN_FAIL = 'USERLOGIN_FAIL';